// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LPxx","col":"styles_col__1tqbT"};